module.exports = __webpack_public_path__ + "images/emoji/clock330.a10e89e30ef3bda51575.png";